import script from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetails.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=20e035b9&lang=scss"

const __exports__ = script;

export default __exports__